var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import { Icon } from '../../utils/icon-utils.js';
import { GGOBaseComponent } from '../ggo.base.component.js';
let ToastComponent = class ToastComponent extends GGOBaseComponent {
    constructor() {
        super(...arguments);
        this.text = '';
        this.variant = 'info';
        this.botPosition = 0;
    }
    static { this.INFO = 'info'; }
    static { this.ERROR = 'error'; }
    static { this.SUCCESS = 'success'; }
    static { this.WARNING = 'warning'; }
    render() {
        this.botPosition = (document.querySelectorAll('ggo-toast').length - 1) * 70;
        return html `
      <div
        class="slds-notify_container slds-is-fixed"
        style="z-index: 9999;top: auto;bottom: ${this.botPosition}px; left: 50%; transform: translateX(-50%); width: auto; pointer-events: none;"
      >
        <div class="slds-notify slds-notify_toast slds-theme_${this.variant}" role="status" style="pointer-events: auto;">
          <span class="slds-assistive-text">info</span>
          <span
            class="slds-icon_container slds-icon-utility-info slds-m-right_small slds-no-flex slds-align-top"
            title="Description of icon when needed"
          >
            ${Icon.getSVGIconTag({
            icon: this.variant,
            sprite: 'utility',
            classes: ['slds-icon', 'slds-icon_small'],
        })}
          </span>
          <div class="slds-notify__content">
            <h2 class="slds-text-heading_small">${this.text}</h2>
          </div>
          <div class="slds-notify__close">
            <button class="slds-button slds-button_icon slds-button_icon-inverse" title="Close" @click="${() => this.close()}">
              ${Icon.getSVGIconTag({
            icon: 'close',
            sprite: 'utility',
            classes: ['slds-button__icon', 'slds-button__icon_large'],
        })}
              <span class="slds-assistive-text">Close</span>
            </button>
          </div>
        </div>
      </div>
    `;
    }
    firstUpdated() {
        setTimeout(() => {
            this.remove();
        }, 4000);
    }
    close() {
        this.remove();
    }
};
__decorate([
    property({ type: String })
], ToastComponent.prototype, "text", void 0);
__decorate([
    property({ type: String })
], ToastComponent.prototype, "variant", void 0);
__decorate([
    query('slot')
], ToastComponent.prototype, "slotElement", void 0);
ToastComponent = __decorate([
    customElement('ggo-toast')
], ToastComponent);
export { ToastComponent };
